<template>
  <base-button class="btn-dark" text="新規登録" />
</template>

<script>
import BaseButton from '@/views/atoms/BaseButton';

export default {
  name: 'AdditionButton',
  components: {
    BaseButton,
  },
}
</script>
